import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
interface MobileCartButtonProps {
  onClick: () => void;
  count: number;
}
export const MobileCartButton = ({
  onClick,
  count
}: MobileCartButtonProps) => {
  return <button className="bg-lime-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center relative z-30" onClick={onClick} aria-label="কার্ট দেখুন (View Cart)" data-id="element-147">
      <ShoppingCartIcon className="h-6 w-6" data-id="element-148" />
      {count > 0 && <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold" data-id="element-149">
          {count}
        </span>}
    </button>;
};